<template>
  <div class="container">
    <div class="row">
      <a @click="downloadReports">Download Reports</a>
    </div>
  </div>
</template>
<script>

export default {
  name: "Reports",
  methods: {
    downloadReports() {
      this.$app.reportManager.getReports();
    }
  }
};
</script>